var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { flatten, get, round } from "lodash";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import qs from "qs";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import history from "@irati/utils/history";
import { FormattedMessage } from "@irati/utils/lang";
import StepIndicator from "@irati/ui/src/StepIndicator";
import Banner from "@irati/ui/src/Banner";
import RewardService from "@irati/reward/apollo/Reward";
import RecognitionService from "@irati/recognition/services/Recognition";
import PaymentService from "@irati/payments/services/Payments";
import rewardBannerImg from "@irati-web/recognition/src/images/banner.png";
import Button from "@irati/ui/src/Button";
import Card from "@irati/ui/src/Layout/Card";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import Loading from "@irati/ui/src/Loading";
import { rewardTracking } from "@irati-tracking/reward";
import ErrorText from "@irati/ui/src/ErrorText";
import PaymentForm from "@irati-web/payments/src/components/PaymentForm";
import { getDomain } from "@irati/utils/links";
import endpoints from "@irati/payments/endpoints";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { Strong } from "@irati/ui/src/Labels";
import { returnUserTextWithAndOrComma } from "@irati/wallet/helpers";
import ConfirmationPopup from "../components/ConfirmationPopup";
import Recipients from "../components/Recipients";
import Message from "../components/Message";
import Checkout from "../components/NewCheckout";
import RecipientList from "../components/Checkout/Steps/Recipients/RecipientList";
import { getTotal } from "../utils";
import { CardHeader, Grid, Hr, Icon, List, RowContent, Summary, SummaryButtons, SummaryRow, TitleContainer, TotalRow } from "../components/styled";
import { StepNames, PaymentType } from "../enums";
var ADD_REWARD_FIRST_STEP = StepNames.Checkout;
var STEPS = [
    { name: StepNames.Recipients, label: React.createElement(FormattedMessage, { id: "reward.steps.recipients.label" }) },
    { name: StepNames.Message, label: React.createElement(FormattedMessage, { id: "reward.steps.message.label" }) },
    { name: StepNames.Checkout, label: React.createElement(FormattedMessage, { id: "reward.steps.checkout.label" }), createOrderNow: true },
    { name: StepNames.Payment, label: React.createElement(FormattedMessage, { id: "reward.steps.payment.label" }) }
];
var orderCreationStep = STEPS.findIndex(function (step) { return step.name === StepNames.Checkout; });
var paymentStep = STEPS.findIndex(function (step) { return step.name === StepNames.Payment; });
var CreateReward = /** @class */ (function (_super) {
    __extends(CreateReward, _super);
    function CreateReward() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            firstStep: 0,
            currentStep: 0,
            recipients: [],
            messageDetails: {
                sharingPreferences: "private",
                companyValues: [],
                message: ""
            },
            paymentMethod: PaymentType.NEW_CARD,
            stepsCount: STEPS.length,
            creatingReward: null,
            reward: null,
            product: null,
            paymentError: "",
            rewardWallet: {},
            updateMessageTracked: false,
            showConfirmationPopup: false
        };
        _this.setProduct = function (product) {
            if (product === void 0) { product = null; }
            // reset creatingReward if previous call thrown error
            _this.setState({ product: product, creatingReward: null });
        };
        _this.setReward = function (reward) {
            if (reward === void 0) { reward = null; }
            if (!reward) {
                // no reward / no product
                // reset creatingReward if previous call errored
                _this.setState({ reward: reward, product: null, creatingReward: null });
            }
            else {
                _this.setState({ reward: reward });
            }
        };
        _this.setRecipients = function (recipients) {
            _this.setState({ recipients: recipients });
        };
        _this.setMessageDetails = function (messageDetails) {
            var reward = _this.state.reward;
            if (reward && reward.isCredit && !_this.state.updateMessageTracked) {
                _this.setState({ updateMessageTracked: true });
                rewardWalletTracking.updateMessage();
            }
            _this.setState({ messageDetails: messageDetails });
        };
        _this.setPaymentMethod = function (paymentMethod) {
            var firstStep = _this.state.firstStep;
            _this.setState({
                paymentMethod: paymentMethod,
                stepsCount: STEPS.length - firstStep
            });
        };
        _this.setOccasion = function (selectedOccasion) {
            _this.setState({ selectedOccasion: selectedOccasion });
        };
        _this.prevStep = function () {
            _this.cleanError();
            var _a = _this.state, currentStep = _a.currentStep, firstStep = _a.firstStep;
            if (currentStep === 1) {
                rewardWalletTracking.backToRecipient();
            }
            if (currentStep === 2) {
                rewardWalletTracking.backToMessage();
            }
            if (currentStep > firstStep) {
                _this.setPrevStep();
            }
        };
        _this.setPrevStep = function () {
            var currentStep = _this.state.currentStep;
            _this.setState({ currentStep: currentStep - 1 });
            window.scrollTo(0, 0);
        };
        _this.setNextStep = function () {
            var currentStep = _this.state.currentStep;
            _this.setState({ currentStep: currentStep + 1 });
            window.scrollTo(0, 0);
        };
        _this.isButtonDisabled = function () {
            var _a = _this.state, currentStep = _a.currentStep, recipients = _a.recipients, messageDetails = _a.messageDetails, reward = _a.reward, product = _a.product, customRewardName = _a.customRewardName, rewardWallet = _a.rewardWallet, paymentMethod = _a.paymentMethod;
            var costTotal = getTotal(product, recipients.length);
            var availableWalletBalance = get(rewardWallet, "availableBalance") || 0;
            var enoughCredit = availableWalletBalance >= costTotal;
            switch (currentStep) {
                case 0:
                    return !recipients.length;
                case 1:
                    if ((messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message) && messageDetails.message.length > 280) {
                        return true;
                    }
                    if ((messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message) && messageDetails.message.length < 281) {
                        return false;
                    }
                    return !(messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message);
                case 2:
                    if (customRewardName)
                        return false;
                    if (paymentMethod === PaymentType.REWARD_WALLET && !enoughCredit)
                        return true;
                    return !reward || !product;
                default:
                    return true;
            }
        };
        _this.handleTracking = function () {
            var _a = _this.state, currentStep = _a.currentStep, recipients = _a.recipients, messageDetails = _a.messageDetails, reward = _a.reward;
            var companyValues = messageDetails.companyValues;
            switch (currentStep) {
                case 0:
                    rewardTracking.rewardsTabAddRewardAddRecipient(recipients);
                    if (get(reward, "isCredit")) {
                        rewardWalletTracking.clickContinueToMessage();
                    }
                    break;
                case 1:
                    rewardTracking.rewardsTabAddRewardAddMessage();
                    rewardTracking.rewardsTabAddRewardAddCompanyValues({ companyValues: companyValues });
                    if (get(reward, "isCredit")) {
                        rewardWalletTracking.clickContinueToCheckout();
                    }
                    break;
                default:
                    break;
            }
        };
        _this.nextStep = function () {
            _this.cleanError();
            var _a = _this.state, currentStep = _a.currentStep, paymentMethod = _a.paymentMethod, reward = _a.reward;
            if (currentStep < orderCreationStep) {
                _this.setNextStep();
            }
            if (currentStep === orderCreationStep) {
                if (paymentMethod === PaymentType.REWARD_WALLET && get(reward, "isCredit")) {
                    _this.setState({ showConfirmationPopup: true });
                }
                else {
                    _this.createOrder();
                }
            }
            _this.handleTracking();
        };
        _this.createOrder = function () {
            var _a = _this.state, paymentMethod = _a.paymentMethod, customRewardName = _a.customRewardName, reward = _a.reward, rewardWallet = _a.rewardWallet;
            var creatingReward = _this.createReward()
                .then(function (_a) {
                var rewardOrder = _a.rewardOrder, paymentOrder = _a.paymentOrder;
                _this.setState(function () { return ({ paymentOrder: paymentOrder, rewardOrder: rewardOrder }); });
                if (customRewardName) {
                    return RecognitionService.updateRecognitionWithRewardId(_this.state.recognitionId, rewardOrder.uuid).then(function () {
                        rewardTracking.rewardsTabAddCustomRewardSuccess({ custom: customRewardName });
                        history.push({ pathname: "/reward/success/" + rewardOrder.uuid }, _this.context);
                    });
                }
                if (paymentMethod === PaymentType.REWARD_WALLET) {
                    // TODO RewardWallet doesn't support credit as a reward yet, we have to use the old wallet transfer for that.
                    // This will go away once the backend will develop that functionality
                    if (get(reward, "isCredit")) {
                        rewardWalletTracking.clickPay();
                        return RewardService.sendCreditAsReward(rewardWallet.uuid, rewardOrder.uuid).then(function () {
                            return RecognitionService.updateRecognitionWithRewardId(_this.state.recognitionId, rewardOrder.uuid).then(function () {
                                rewardTracking.rewardsTabCreditSend();
                                history.push({ pathname: "/reward/success/" + rewardOrder.uuid }, _this.context);
                            });
                        });
                    }
                    return _this.payByRewardWallet();
                }
            });
            _this.setState({ creatingReward: creatingReward });
            _this.setNextStep();
        };
        _this.handleHide = function () {
            _this.setState({ showConfirmationPopup: false });
        };
        _this.createReward = function () {
            var _a = _this.state, reward = _a.reward, product = _a.product, recipients = _a.recipients, messageDetails = _a.messageDetails, customRewardName = _a.customRewardName, addRewardEntity = _a.addRewardEntity, addRewardEntityType = _a.addRewardEntityType, selectedOccasion = _a.selectedOccasion;
            var _b = _this.props.auth, business = _b.business, userTeamIds = _b.user.teamIds;
            var recipientIds = recipients.map(function (user) { return user.uuid; });
            var rewardPayload = {
                tenantId: business === null || business === void 0 ? void 0 : business.uuid,
                rewardId: reward === null || reward === void 0 ? void 0 : reward.uuid,
                productId: product === null || product === void 0 ? void 0 : product.uuid,
                recipientUserIds: recipientIds,
                message: messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message,
                custom: customRewardName,
                isCreditReward: reward === null || reward === void 0 ? void 0 : reward.isCredit
            };
            _this.paymentCompleted = false;
            if (!addRewardEntity) {
                var recognitionPayload = {
                    companyValues: messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.companyValues,
                    teamIds: flatten(recipients.map(function (_a) {
                        var teamIds = _a.teamIds;
                        return teamIds;
                    })).concat(userTeamIds),
                    userIds: recipientIds,
                    isPrivate: (messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.sharingPreferences) === "private",
                    message: messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message,
                    occasionId: selectedOccasion,
                    expectReward: true
                };
                return RecognitionService.create(recognitionPayload)
                    .then(function (_a) {
                    var recognitionId = _a.uuid;
                    _this.setState({ recognitionId: recognitionId });
                    return RewardService.create(rewardPayload);
                });
            }
            if (addRewardEntityType === "poll") {
                rewardPayload.poll_id = addRewardEntity.uuid;
            }
            else {
                rewardPayload.recognition_id = addRewardEntity.uuid;
            }
            _this.setState({ rewardEntityId: addRewardEntity.uuid });
            return RewardService.create(rewardPayload);
        };
        _this.payByRewardWallet = function () {
            var _a = _this.state, rewardOrder = _a.rewardOrder, paymentOrder = _a.paymentOrder;
            var amount = { amount: round(rewardOrder.costTotal.amount * 100) };
            return PaymentService.payByRewardWallet(paymentOrder, amount, rewardOrder).then(_this.paymentComplete);
        };
        _this.paymentCompleted = false;
        _this.paymentComplete = function () {
            if (_this.paymentCompleted)
                return;
            _this.paymentCompleted = true;
            var _a = _this.state, rewardOrder = _a.rewardOrder, reward = _a.reward, recipients = _a.recipients, recognitionId = _a.recognitionId, rewardEntityId = _a.rewardEntityId, addRewardEntityType = _a.addRewardEntityType;
            var rewardOrderId = rewardOrder.uuid;
            return RewardService.confirmRewardPaymentOrder(rewardOrderId)
                .then(function () {
                if (rewardEntityId && addRewardEntityType === "poll") {
                    return RecognitionService.updatePollWithRewardId(rewardEntityId, rewardOrderId);
                }
                return RecognitionService.updateRecognitionWithRewardId(rewardEntityId || recognitionId, rewardOrderId);
            })
                .then(function () {
                var recipientsCount = recipients.length;
                var rewardTotal = rewardOrder.costTotal;
                var rewardHeader = reward.header;
                rewardTracking.rewardsTabAddRewardSuccess(recipientsCount, rewardTotal, rewardHeader);
                history.push({ pathname: "/reward/success/" + rewardOrderId }, _this.context);
            })
                .catch(function () {
                // Payment failed, we aren't getting any code from BE of why it failed, posting generic message
                _this.setState({ paymentError: "reward.genericPaymentError" });
                _this.setPrevStep();
            });
        };
        _this.cleanError = function () {
            _this.setState({ paymentError: "" });
        };
        _this.getPaymentRedirectUrl = function () {
            var _a = _this.state, rewardOrder = _a.rewardOrder, recognitionId = _a.recognitionId, rewardEntityId = _a.rewardEntityId, addRewardEntityType = _a.addRewardEntityType;
            var subdomain = _this.props.auth.business.subdomain;
            var domain = getDomain(subdomain);
            var entityType = addRewardEntityType || "recognition";
            var entityId = rewardEntityId || recognitionId;
            var query = qs.stringify({
                redirectTo: domain + "/recognition/reward/complete-payment/" + rewardOrder.uuid + "/" + entityType + "/" + entityId
            });
            return endpoints.adyenRedirectCallbackUrl() + "?" + query;
        };
        _this.buildUsers = function () {
            var recipients = _this.state.recipients;
            return recipients
                .map(_this.userToNameAndEmail);
        };
        _this.userToNameAndEmail = function (user, index) {
            var recipients = _this.state.recipients;
            var text = returnUserTextWithAndOrComma(recipients.length, index, "reward.sendCreditAsReward.confirmationPopup.text1.user", "reward.sendCreditAsReward.confirmationPopup.text1.userWithComma", "reward.sendCreditAsReward.confirmationPopup.text1.userWithAnd");
            return (React.createElement("div", { className: "text-center", key: user.uuid },
                React.createElement(FormattedMessage, { id: text, values: {
                        name: firstnameLastname(user),
                        email: user.email
                    } })));
        };
        _this.handleConfirmation = function () {
            _this.handleHide();
            _this.createOrder();
        };
        return _this;
    }
    CreateReward.prototype.componentDidMount = function () {
        var _this = this;
        var auth = this.props.auth;
        // Identify and initialise flow based on route state:
        // Create Reward params
        var product = get(this.props, "location.state.product");
        var reward = get(this.props, "location.state.reward");
        // Add Reward params
        var type = get(this.props, "location.state.type");
        var item = get(this.props, "location.state.item");
        // CustomReward params
        var customRewardName = get(this.props, "location.state.customRewardName");
        var isCreatingReward = product && reward;
        var isAddingReward = type && item;
        if (isCreatingReward || isAddingReward || customRewardName) {
            var state_1 = __assign({}, this.state);
            if (customRewardName) {
                state_1.customRewardName = customRewardName;
            }
            else if (isAddingReward) {
                state_1.firstStep = STEPS.findIndex(function (step) { return step.name === ADD_REWARD_FIRST_STEP; });
                state_1.currentStep = state_1.firstStep;
                state_1.stepsCount = STEPS.length - state_1.firstStep;
                state_1.addRewardEntityType = type;
                state_1.addRewardEntity = item;
                state_1.selectedOccasion = get(item, "occasion.uuid");
                if (type === "poll") {
                    state_1.recipients = item.winners.results.map(function (winner) { return winner.user; });
                    state_1.messageDetails.message = item.desc;
                }
                else {
                    state_1.recipients = item.receivers.results;
                    state_1.messageDetails.message = item.message;
                }
            }
            else {
                state_1.reward = reward;
                state_1.product = product;
            }
            if (get(auth.productPermissions, "wallet.rewardWallet")) {
                RewardService.getWallet().then(function (wallet) {
                    state_1.rewardWallet = wallet;
                    _this.setState(function () { return state_1; });
                });
            }
            else {
                this.setState(function () { return state_1; });
            }
        }
        else {
            history.push({ pathname: "/reward" }, this.context);
        }
    };
    CreateReward.prototype.render = function () {
        var _a = this.state, reward = _a.reward, product = _a.product, recipients = _a.recipients, messageDetails = _a.messageDetails, currentStep = _a.currentStep, creatingReward = _a.creatingReward, paymentOrder = _a.paymentOrder, rewardOrder = _a.rewardOrder, paymentMethod = _a.paymentMethod, stepsCount = _a.stepsCount, customRewardName = _a.customRewardName, firstStep = _a.firstStep, rewardWallet = _a.rewardWallet, paymentError = _a.paymentError, addRewardEntity = _a.addRewardEntity, selectedOccasion = _a.selectedOccasion, showConfirmationPopup = _a.showConfirmationPopup;
        var bannerImage = get(reward, "bannerImage");
        var isCredit = get(reward, "isCredit", false);
        var buttonLabel = "reward.detail.btnContinue.label";
        if (currentStep === orderCreationStep) {
            if (paymentMethod === PaymentType.REWARD_WALLET) {
                buttonLabel = "reward.confirmation.button.title";
            }
            else if (customRewardName) {
                buttonLabel = "reward.customReward.summary.button";
            }
        }
        var amount = product && formatCurrency({ value: getTotal(product, recipients.length), isCents: false });
        return (React.createElement(React.Fragment, null,
            React.createElement(Banner, { bannerImg: bannerImage || rewardBannerImg }),
            React.createElement(Grid, null,
                React.createElement(Row, null,
                    React.createElement(Col, { md: 8 },
                        React.createElement(Card, null,
                            React.createElement(CardHeader, null,
                                React.createElement(TitleContainer, null,
                                    React.createElement("h4", null, STEPS[currentStep].label),
                                    React.createElement(StepIndicator, { currentStep: currentStep - firstStep + 1, stepsCount: stepsCount }))),
                            currentStep === 0 && React.createElement(Recipients, { recipients: recipients, setRecipients: this.setRecipients, isCredit: isCredit }),
                            currentStep === 1 && (React.createElement(Message, { recipients: recipients, messageDetails: messageDetails, selectedOccasion: selectedOccasion, setOccasion: this.setOccasion, setMessageDetails: this.setMessageDetails, isCredit: isCredit })),
                            currentStep === 2 && (React.createElement(Checkout, { product: product, reward: reward, customRewardName: customRewardName, recipientsCount: recipients.length, setPaymentMethod: this.setPaymentMethod, addRewardEntity: addRewardEntity, selectedOccasion: selectedOccasion, setOccasion: this.setOccasion, paymentMethod: paymentMethod, setProduct: this.setProduct, setReward: this.setReward, rewardWallet: rewardWallet, isCredit: isCredit })),
                            currentStep === 3 && (React.createElement(Loading, { load: creatingReward }, rewardOrder && !customRewardName && (React.createElement(PaymentForm, { paymentOrder: paymentOrder, amount: rewardOrder.costTotal.amount * 100, onComplete: this.paymentComplete, redirectReturnUrl: this.getPaymentRedirectUrl() })))))),
                    React.createElement(Col, { md: 4 },
                        React.createElement(Summary, null,
                            React.createElement("h4", null,
                                React.createElement(FormattedMessage, { id: "reward.summary.title" })),
                            (!!recipients.length || (messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message)) && (React.createElement(SummaryRow, null,
                                React.createElement(Icon, { icon: "person", size: 23 }),
                                React.createElement(RowContent, null,
                                    React.createElement(List, null,
                                        React.createElement(RecipientList, { recipients: recipients }))))),
                            (messageDetails === null || messageDetails === void 0 ? void 0 : messageDetails.message) && (React.createElement(SummaryRow, null,
                                React.createElement(Icon, { icon: "heartOutline", size: 23 }),
                                React.createElement(RowContent, null, messageDetails.message))),
                            React.createElement(Hr, null),
                            customRewardName && (React.createElement(SummaryRow, null,
                                React.createElement(Icon, { icon: "customReward", size: 23 }),
                                React.createElement("p", null, customRewardName))),
                            product && (React.createElement(SummaryRow, null,
                                React.createElement(Icon, { icon: "reward", size: 23 }),
                                React.createElement("p", null, get(product, "product.name")))),
                            product && (React.createElement(TotalRow, null,
                                React.createElement("h5", null,
                                    React.createElement(FormattedMessage, { id: "reward.summary.totalToPay" })),
                                React.createElement("h4", null, amount))),
                            currentStep < paymentStep && (React.createElement(Loading, { load: creatingReward },
                                React.createElement(SummaryButtons, null,
                                    currentStep > firstStep && (React.createElement(Button, { secondary: true, onClick: this.prevStep },
                                        React.createElement(FormattedMessage, { id: "reward.summary.back.label" }))),
                                    React.createElement(Button, { primary: true, disabled: this.isButtonDisabled(), onClick: this.nextStep },
                                        React.createElement(FormattedMessage, { id: buttonLabel }))))),
                            paymentError && (React.createElement(ErrorText, null,
                                React.createElement(FormattedMessage, { id: paymentError }))))))),
            !!recipients.length && product &&
                React.createElement(ConfirmationPopup, { title: "reward.sendCreditAsReward.confirmationPopup.title", topText: React.createElement(React.Fragment, null,
                        React.createElement(FormattedMessage, { id: "reward.sendCreditAsReward.confirmationPopup.text1.top", values: { credit: amount } }),
                        this.buildUsers()), bottomText: React.createElement(FormattedMessage, { id: "reward.sendCreditAsReward.confirmationPopup.text2", values: {
                            boldText: (React.createElement(Strong, null,
                                React.createElement(FormattedMessage, { id: "reward.sendCreditAsReward.confirmationPopup.text2Bold" })))
                        } }), show: showConfirmationPopup, onHide: this.handleHide, onClick: this.handleConfirmation, backButtonText: "reward.sendCreditAsReward.confirmationPopup.backButton", continueButtonText: "reward.sendCreditAsReward.confirmationPopup.sendButton" })));
    };
    CreateReward.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return CreateReward;
}(Component));
export default withRouter(withAuth(CreateReward));
